import React, { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { ScoreHero } from "@/components/prime/growth/ScoreHero";
import { GrowthPath } from "@/components/prime/growth/GrowthPath";
import { MetricCards } from "@/components/prime/growth/MetricCards";
import { TeamSection, SystemsSection, ReinvestSection } from "@/components/prime/growth/GrowthSections";
import { GrowthActions } from "@/components/prime/growth/GrowthActions";

export function usePathToPrime() {
  const [d, setD] = useState(undefined);
  const load = useCallback(() => { api.get("/prime/my-growth").then((r) => setD(r.data)).catch(() => setD(null)); }, []);
  useEffect(() => { load(); }, [load]);
  return [d, load];
}

export function PathToPrimeContent({ d, reload }) {
  const c = d.content;
  return (
    <div className="space-y-8" data-testid="path-to-prime">
      <ScoreHero agencies={d.agencies} intro={c.intro} rulesYear={d.rules_year} />
      <GrowthPath content={c} />
      <TeamSection content={c} isAgent={d.is_agent} />
      <SystemsSection content={c} />
      <MetricCards guidelinesAvailable={d.guidelines_available} guidelinesLabel={c.guidelines_label} kpis={d.kpis} current={d.agencies.find((a) => a.role !== "staff")?.current} />
      <ReinvestSection content={c} />
      <GrowthActions actions={d.actions} selected={d.selected_actions} readOnly={d.read_only} scheduleUrl={d.schedule_url}
        scheduleLabel={d.schedule_label} onAdded={reload} ryder={c.ryder_systems_enabled} />
      <p className="text-[11px] text-slate-400">Coaching suggestions and personal action plans come from your district team. They aren't Farmers requirements. Official results and rules come from Farmers' Prime reporting and the {d.rules_year} program guidelines.</p>
    </div>
  );
}

export default function PathToPrime() {
  const [d, load] = usePathToPrime();
  if (d === undefined) return <p className="text-sm text-slate-400 p-6">Loading…</p>;
  if (d === null) return <p className="text-sm text-slate-500 p-6" data-testid="growth-unavailable">Your Path to PRIME is available to Agents and Agent Staff.</p>;
  return <div className="max-w-6xl mx-auto p-4 sm:p-6"><PathToPrimeContent d={d} reload={load} /></div>;
}
